<template>
  <ContentDialog
    ref="contentDialog"
    :max-width="1000"
    :title="form?.name || undefined"
    closeable
  >
    <template
      v-if="loaded"
      #content
    >
      <template v-if="loaded">
        <QuestionSet
          v-model="form"
          @change:attachments="loadAttachments"
          :attachment-owner-id="form.id"
          :attachment-owner-type="'Form'"
          :attachments="attachments"
          :autofocus="autofocus"
          :questions="validPublishedQuestions"
          :schema="schema.definition"
          key-name="question"
          expanded
          hide-actions
          readonly
        />
      </template>

      <template v-else>
        <v-progress-linear
          class="my-8"
          indeterminate
        />
      </template>
    </template>
  </ContentDialog>
</template>

<script setup>
import { useStore } from 'vuex';

import ContentDialog from '@/shared/components/ContentDialog.vue';
import QuestionSet from '@/shared/components/form/QuestionSet.vue';
import useApi from '@/shared/composables/useApi';
import useQuestionable from '@/shared/composables/useQuestionable';

defineExpose({ open });

const { api } = useApi();

const attachments = ref([]);
const form = ref(null);
const schema = ref(null);
const store = useStore();

// Template refs
const contentDialog = ref(null);

const loaded = computed(() => questionsLoaded.value && validPublishedQuestions.value.length > 0);
const schemaId = computed(() => schema.value?.id);

const { questionsLoaded, validPublishedQuestions } = useQuestionable({
  ownerDataTypeRef: ref('Schema'),
  ownerIdRef: schemaId,
  syncedObjectRef: form,
});

async function loadAttachments() {
  const response = await api.manager.attachment.index({
    owner_type: 'Form',
    owner_id: form.value.id,
  });
  if (response?.status !== 200) return;

  attachments.value = response.data;
}

async function open(newForm) {
  form.value = newForm;
  schema.value = store.state.schemas[form.value.schema_id];
  await loadAttachments();
  contentDialog.value?.open();
}
</script>
